import jwtDecode from 'jwt-decode';
import * as CryptoJS from 'crypto-js';
import * as constants from '../helpers/constants';

const ZedriqoTix: any = dec_txt(constants.no_name);

function dec_txt(data_enc: string): string {
  const bytes = CryptoJS.AES.decrypt(data_enc, atob(constants.vbasvdbvasbvbds));
  return bytes.toString(CryptoJS.enc.Utf8);

}

function aesDecrypt(data: any) {
  var key = CryptoJS.enc.Utf8.parse(ZedriqoTix);
  var decrypted = CryptoJS.AES.decrypt((data), key, {
    keySize: 16,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
  try {
    return JSON.parse(decryptedString);
  } catch (e) {
    console.error('Error parsing decrypted token data', e);
    return {};
  }
}

export function customJwtDecode<T = unknown>(token: string): T {
  const decoded: any = jwtDecode(token);

  if (decoded && decoded.data) {
    const decryptedData = aesDecrypt(decoded.data);
    // Merge decrypted data into the main object, replacing 'data' if needed or just extending
    // Based on backend implementation, 'data' contains the ENTIRE original payload.
    // So we should return the decrypted object merged with standard claims (iat, exp, etc) if necessary,
    // or just the decrypted object if it contains everything.
    // The backend encrypts ONLY the user data object result. Standard claims like exp might be outside?
    // Let's re-read backend code.
    // Backend: jwt.sign({ data: encrypt(payload) }, secret, { expiresIn: ... })
    // So 'decoded' will check: { data: "...", iat: ..., exp: ... }.
    // We want to return { ...decryptedPayload, iat: ..., exp: ... }

    if (decryptedData) {
      return { ...decoded, ...decryptedData, data: undefined };
    }
  }

  return decoded;
}